export default "__VITE_ASSET__BhYGz7pG__"